import { Component, Input } from '@angular/core';
import { Entry } from '../../../entry.model'; // import Interface

@Component({
  selector: 'app-entry',
  templateUrl: './entry.component.html',
  styleUrls: ['./entry.component.css']
})
export class EntryComponent {
  @Input() entry: Entry; // Assigning the Entry Interface to entry.

  onCommentAdded(comments: {name: string, comment: string;}){
    this.entry.comments.push(comments)
  }
}



// WEBPACK FOOTER //
// C:/Users/Aimee/Desktop/git/Angular/aimees-photo-blog/src/app/components/entries/entry/entry.component.ts